type RouterFunc = (...args) => string;

class RouteConstructor {
  func: RouterFunc;
  constructor(func: RouterFunc) {
    this.func = func;
  }

  href(...args): string {
    return this.func(...args);
  }
}
const routeHelper = {
  maintenance: new RouteConstructor(() => `/maintenance`),
  accountRecoveryStep: new RouteConstructor(step => `/account-recovery/${step}`),
  accountRecovery: new RouteConstructor(() => `/account-recovery`),
  artistIdentification: new RouteConstructor(() => `/artist-identification`),
  contactSupport: new RouteConstructor(() => `/contact-support`),
  disambiguation: new RouteConstructor(() => `/disambiguation`),
  unableToRecover: new RouteConstructor(() => `/unable-to-recover`),

  additionalClaimWelcome: new RouteConstructor(() => `/additional-claim-welcome`),
  claimAdditionalAccount: new RouteConstructor(() => `/claim-additional-account`),
  createAccount: new RouteConstructor(() => `/create-account`),
  resetEmail: new RouteConstructor(() => `/reset-email`),

  foundProfiles: new RouteConstructor(() => `/found-profiles`),
  mapProfiles: new RouteConstructor(() => `/map-profiles`),
  onboarding: new RouteConstructor(() => `/onboarding`),
  onboardingAdditionalAccount: new RouteConstructor(() => `/onboarding-additional-account`),
  organizationClaim: new RouteConstructor(() => `/organization-claim`),
  personalProfile: new RouteConstructor(() => `/personal-profile`),
  selectPersonalProfile: new RouteConstructor(() => `/select-personal-profile`),

  verifiedAccount: new RouteConstructor(() => `/verified-account`),
  verifiedEmail: new RouteConstructor(() => `/verify-email`),

  maxClaimsReached: new RouteConstructor(() => `/max-claims-reached`),
  stubPage: new RouteConstructor(() => `/stub-page`),

  claimSuccess: new RouteConstructor(() => `/claim-success`),
  projectCreatorInformation: new RouteConstructor(() => '/project-creator-information'),
  root: new RouteConstructor(() => '/'),
};

export default routeHelper;
